// أدوات مشتركة لميزة «رسائل واتساب الجاهزة» — روابط wa.me فقط، بلا API خارجي وبلا إرسال آلي

// يطبّع أي رقم جوال (سعودي أو دولي) لصيغة wa.me: أرقام فقط، مثل 9665XXXXXXXX
export const normalizeWhatsAppNumber = (raw, defaultCountryCode = '966') => {
  if (!raw) return null;
  let digits = String(raw).trim().replace(/[^\d+]/g, '');
  if (!digits) return null;
  if (digits.startsWith('+')) digits = digits.slice(1);
  else if (digits.startsWith('00')) digits = digits.slice(2);

  const cc = String(defaultCountryCode || '966').replace(/\D/g, '') || '966';

  if (digits.startsWith('0')) {
    digits = cc + digits.replace(/^0+/, '');
  } else if (!digits.startsWith(cc) && digits.length <= 10) {
    digits = cc + digits;
  }

  return /^\d{8,15}$/.test(digits) ? digits : null;
};

export const buildWaMeLink = (normalizedNumber, text) => `https://wa.me/${normalizedNumber}?text=${encodeURIComponent(text || '')}`;

// يعبّئ {{variable}} ببيانات فعلية، ولا يترك أبداً undefined أو null داخل النص
export const fillTemplate = (body, variables = {}) => {
  if (!body) return '';
  return body.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
    const val = variables[key];
    return val === undefined || val === null || val === '' ? '' : String(val);
  }).replace(/[ \t]+\n/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
};

// نفس منطق صلاحية can_communicate المستخدم في القائمة الجانبية وخادم واتساب
export const canUseWhatsApp = (user) => {
  if (!user) return false;
  return !!user.is_super_admin || user.role === 'admin' || user.role === 'manager' || !!user.can_communicate;
};

export const VARIABLE_LABELS = {
  guardian_name: 'اسم ولي الأمر',
  player_name: 'اسم اللاعب',
  club_name: 'اسم المنشأة',
  subscription_name: 'اسم الاشتراك',
  expiry_date: 'تاريخ الانتهاء',
  paid_amount: 'المبلغ المدفوع',
  remaining_amount: 'المبلغ المتبقي',
  training_date: 'موعد التدريب',
  match_date: 'موعد المباراة',
  location: 'المكان',
  payment_reference: 'مرجع الدفع',
};
